import {
  ArrayNotEmpty,
  IsArray,
  IsBoolean,
  IsInt,
  IsISO8601,
  IsNumber,
  IsOptional,
  IsString,
  Matches,
  ValidateIf
} from 'class-validator';
import { Type } from 'class-transformer';
import { RebateTypesEnum } from '../../enum/rebate';

export class CreateRebateBodyDto {
  @IsString()
  name: string;

  @IsInt()
  supplierId: number;

  @IsInt()
  rebateTypeId: number;

  @IsOptional()
  @IsInt()
  settlementFrequencyId?: number;

  @IsString()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  startDate: string;

  @IsOptional()
  @IsString()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  endDate?: string;

  @IsInt()
  criteriaTypeId: number;

  @IsOptional()
  @IsNumber()
  criteriaValue?: number;

  @IsOptional()
  @IsNumber()
  monetaryFixedAmount?: number;

  @IsOptional()
  @IsNumber()
  monetaryPercentageOfSpend?: number;

  @IsOptional()
  @IsNumber()
  monetaryFixedValue?: number;

  @IsOptional()
  @IsInt()
  monetaryPaymentMethodId?: number;

  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  monetaryIsInvoiceRequired?: boolean;

  @IsOptional()
  @IsNumber()
  productVolume?: number;

  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  productIsPORequired?: boolean;

  @IsInt()
  merchantGroupId: number;

  // will be added at API level
  /*  @IsOptional()
    @IsInt()
    createdByUserId?: boolean;*/

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  merchantIds?: number[];



  // Dynamically check that if rebateType is CATEGORY_PURCHASES, stockCategoryIds is present, if rebate type is STOCK_PURCHASES stockIds is present

  @ValidateIf(o => o.rebateTypeId === RebateTypesEnum.CATEGORY_PURCHASES)
  @IsArray()
  @ArrayNotEmpty()
  @IsNumber({}, { each: true })
  stockCategoryIds?: number[];

  @ValidateIf(o => o.rebateTypeId === RebateTypesEnum.STOCK_PURCHASES)
  @IsArray()
  @ArrayNotEmpty()
  @IsNumber({}, { each: true })
  stockIds?: number[];

}